(function ($) {
    $(document).ready(function () {
        const logos_slider = $('.slick-slider.logos');
        if (logos_slider.length) {
            logos_slider.each(function () {
                const id = $(this).attr('id');
                $(this).slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    centerMode: true,
                    autoplay: true,
                    autoplaySpeed: 0,
                    speed: 4000,
                    variableWidth: true,
                    cssEase: 'linear',
                    initialSlide: 1,
                    // 'prevArrow': '.slick-prev.slick-arrow',
                    // 'nextArrow': '.slick-next.slick-arrow'
                });
            });
        }

        const testimonials_slider = $('.slick-slider.testimonials');
        if (testimonials_slider.length) {
            testimonials_slider.each(function () {
                const id = $(this).attr('id');
                $(this).slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: false,
                    centerMode: false,
                    prevArrow: $(`.slick-prev.slick-arrow[data-slider_id="${id}"]`),
                    nextArrow: $(`.slick-next.slick-arrow[data-slider_id="${id}"]`),
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: false,
                                centerMode: false,
                                prevArrow: $(`.slick-prev.slick-arrow[data-slider_id="${id}"]`),
                                nextArrow: $(`.slick-next.slick-arrow[data-slider_id="${id}"]`),
                            }
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: false,
                                centerMode: false,
                                adaptiveHeight: true,
                                prevArrow: $(`.slick-prev.slick-arrow[data-slider_id="${id}"]`),
                                nextArrow: $(`.slick-next.slick-arrow[data-slider_id="${id}"]`),
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: false,
                                centerMode: false,
                                adaptiveHeight: true,
                                prevArrow: $(`.slick-prev.slick-arrow[data-slider_id="${id}"]`),
                                nextArrow: $(`.slick-next.slick-arrow[data-slider_id="${id}"]`),
                            }
                        }
                    ]
                });
            });
        }

        const gallery_slider = $('.slick-slider.gallery');
        if (gallery_slider.length) {
            gallery_slider.each(function () {
                const id = $(this).attr('id');
                $(this).slick({
                    'infinite': false,
                    slidesToShow: 1,
                    slidesToScroll: 1,

                    centerPadding: '300px',
                    arrows: true,
                    centerMode: true,

                    prevArrow: $(`.slick-prev.slick-arrow[data-slider_id="${id}"]`),
                    nextArrow: $(`.slick-next.slick-arrow[data-slider_id="${id}"]`),

                    dots: true,

                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                centerPadding: '150px',
                                infinite: false,
                                centerMode: true,
                                prevArrow: $(`.slick-prev.slick-arrow[data-slider_id="${id}"]`),
                                nextArrow: $(`.slick-next.slick-arrow[data-slider_id="${id}"]`),
                            }
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                centerPadding: '80px',
                                infinite: false,
                                centerMode: true,
                                prevArrow: $(`.slick-prev.slick-arrow[data-slider_id="${id}"]`),
                                nextArrow: $(`.slick-next.slick-arrow[data-slider_id="${id}"]`),
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                centerPadding: '60px',
                                centerMode: true,
                                prevArrow: $(`.slick-prev.slick-arrow[data-slider_id="${id}"]`),
                                nextArrow: $(`.slick-next.slick-arrow[data-slider_id="${id}"]`),
                            }
                        }
                    ]
                    // 'prevArrow': '.slick-prev.slick-arrow',
                    // 'nextArrow': '.slick-next.slick-arrow'
                });
            });
        }
    });
})(jQuery);